import ApplicationController from './application_controller'

import { Html5QrcodeScanner } from 'html5-qrcode'

export default class extends ApplicationController {
  static targets = ['video', 'resourceId', 'resourceType']

  connect () {
    this.qrScanner = new Html5QrcodeScanner('reader', { })
    this.qrScanner.render(this.onScanSuccess.bind(this), this.onScanFailure.bind(this))
    this.isProcessing = false
    this.cooldownTime = 2000
  }

  onScanSuccess(decodedText, decodedResult) {
    if (this.isProcessing) {
      return
    }

    this.isProcessing = true

    try {
      var data = JSON.parse(decodedText)
      var form = document.getElementById('scan_form')

      if (typeof(data) === 'number') {
        form.querySelector('#scan_id').value = data
      } else if (typeof(data) === 'object') {
        form.querySelector('#scan_type').value = data.type
        form.querySelector('#scan_id').value = data.id
      }

      form.submit()
    } catch (error) {
      console.error('Error parsing barcode:', error)
      this.isProcessing = false
    }

    setTimeout(() => {
      this.isProcessing = false
    }, this.cooldownTime)
  }

  onScanFailure(error) {
    console.log(error)
  }

  disconnect() {
    if (this.qrScanner) {
      this.qrScanner.clear()
    }
  }
}
